"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkOSLA7LY6js = require('./chunk-OSLA7LY6.js');var _chunkO75FFXETjs = require('./chunk-O75FFXET.js');var _chunkTRCGOSUFjs = require('./chunk-TRCGOSUF.js');var _chunkHX4MSBP2js = require('./chunk-HX4MSBP2.js');var _chunkDNBWNURQjs = require('./chunk-DNBWNURQ.js');var _chunkPOE2IUJUjs = require('./chunk-POE2IUJU.js');var _chunkMQ5AGG7Cjs = require('./chunk-MQ5AGG7C.js');var _chunkDJMNXU7Ljs = require('./chunk-DJMNXU7L.js');var _chunkBDF663TKjs = require('./chunk-BDF663TK.js');var _chunkSKRBKJ52js = require('./chunk-SKRBKJ52.js');var _chunkOL2KRAIPjs = require('./chunk-OL2KRAIP.js');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _react = require('react'); var _react2 = _interopRequireDefault(_react);var _jsxruntime = require('react/jsx-runtime');var J=_styled2.default.a`
  display: flex;
  flex-flow: column;
  cursor: pointer;
  width: ${e=>e.theme.measurements.spacing(136)};
  max-width: ${e=>e.theme.measurements.spacing(136)};
`,K=_styled2.default.div`
  position: relative;
  display: block;
  min-width: fit-content;
  height: ${e=>e.theme.measurements.spacing(78)};
  img {
    width: 100%;
    max-width: ${e=>e.theme.measurements.spacing(136)};
    height: ${e=>e.theme.measurements.spacing(78)};
    border-radius: ${e=>e.theme.measurements.shape(2)};
  }
`,Q=_styled2.default.div`
  display: flex;
  flex-flow: column;
  position: absolute;
  bottom: ${e=>e.theme.measurements.spacing(6)};
  gap: ${e=>e.theme.measurements.spacing(4)};
  left: ${e=>e.theme.measurements.spacing(6)};
  right: ${e=>e.theme.measurements.spacing(6)};
`,X=_styled2.default.div`
  display: flex;
  align-items: flex-end;
`,Z=_styled2.default.div`
  display: flex;
  gap: ${e=>e.theme.measurements.spacing(4)};
  justify-content: flex-start;
  flex: 1;
`,ee=_styled2.default.call(void 0, _chunkPOE2IUJUjs.a)`
  text-transform: uppercase;
  padding: ${e=>e.theme.measurements.spacing(2)}
    ${e=>e.theme.measurements.spacing(3)};
`,M=_styled2.default.call(void 0, _chunkDNBWNURQjs.a)`
  border: none;
  border-radius: ${e=>e.theme.measurements.spacing(16)};
  padding: ${e=>e.theme.measurements.spacing(4)};
  min-width: ${e=>e.theme.measurements.spacing(16)};
  min-height: ${e=>e.theme.measurements.spacing(16)};
`,te=_styled2.default.call(void 0, _chunkPOE2IUJUjs.a)`
  border: none;
  display: flex;
  gap: ${e=>e.theme.measurements.spacing(2)};
  font-weight: 600;
`,ae=_styled2.default.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  &.align-item-left {
    justify-content: flex-start;
  }
`,se=_styled2.default.div`
  display: flex;
  flex-flow: column;
  margin-top: ${e=>e.theme.measurements.spacing(6)};
  gap: ${e=>e.theme.measurements.spacing(3)};
`,ne=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.a)`
  line-height: ${e=>e.theme.measurements.spacing(12)};
`,ie=_styled2.default.div`
  display: flex;
  flex-direction: row;
  gap: ${e=>e.theme.measurements.spacing(4)};
  align-items: center;
`,oe=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.a)`
  color: ${e=>e.$topicColor||e.theme.palette.VIOLET};
  font-size: ${e=>e.theme.measurements.spacing(6)};
  font-weight: 700;
  line-height: ${e=>e.theme.measurements.spacing(6)};
  text-transform: uppercase;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`,I=_styled2.default.div`
  font-size: ${e=>e.theme.measurements.spacing(7)};
  line-height: ${e=>e.theme.measurements.spacing(10)};
  color: ${e=>e.theme.palette.SECONDARY};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`,re=_styled2.default.call(void 0, I)`
  a {
    color: ${e=>e.theme.palette.SECONDARY};
  }
`,le=_styled2.default.call(void 0, I)``,me=_styled2.default.call(void 0, _chunkPOE2IUJUjs.a)`
  white-space: nowrap;
`,ce=_react2.default.forwardRef((e,k)=>{let{title:g,langLabel:R="EN",variant:s,showPlayButton:m=!0,showNotifyButton:D=!1,viewCount:u=0,progress:c=0,topicName:B,topicColor:p,educatorName:o,detailsLine:f,ariaLabel:P,dataTestId:A,className:H,onClick:h,href:U,newTab:z,onNotify:r,thumbnail:C,educatorLink:v="",as:W="a",notified:S=!1}=e,q=_chunkOL2KRAIPjs.b.call(void 0, ),O=_react.useMemo.call(void 0, ()=>s==="Continue Watching"&&c,[s,c]),V=n=>{!r||(n.preventDefault(),r(n))},j=n=>{!r||(n.preventDefault(),r(n))},F=n=>{!h||(n.preventDefault(),h(n))},Y=n=>{n.stopPropagation()};return _jsxruntime.jsxs.call(void 0, J,{as:W,ref:k,className:`${H||""} aquilla-classcard classcard`,onClick:F,href:U,"aria-label":P,"data-testid":A,title:g,rel:"noopener noreferrer",target:z?"_blank":"_self",children:[_jsxruntime.jsxs.call(void 0, K,{children:[C?_jsxruntime.jsx.call(void 0, C,{}):"",_jsxruntime.jsxs.call(void 0, Q,{children:[_jsxruntime.jsxs.call(void 0, X,{children:[s!=="Upcoming"?_jsxruntime.jsxs.call(void 0, Z,{children:[s==="Live"?_jsxruntime.jsx.call(void 0, ee,{variant:"solid",color:q.RED,size:"small",children:"Live"}):"",u?_jsxruntime.jsxs.call(void 0, te,{size:"small",variant:"default",children:[_jsxruntime.jsx.call(void 0, _chunkBDF663TKjs.b,{height:16,width:16})," ",u]}):""]}):"",_jsxruntime.jsxs.call(void 0, ae,{className:s==="Upcoming"?"align-item-right":"",children:[s==="Live"&&m?_jsxruntime.jsx.call(void 0, _chunkTRCGOSUFjs.a,{}):"",s==="Upcoming"&&D&&(S?_jsxruntime.jsx.call(void 0, M,{variant:"secondary",onClick:j,children:_jsxruntime.jsx.call(void 0, _chunkDJMNXU7Ljs.b,{height:24,width:24})}):_jsxruntime.jsx.call(void 0, M,{variant:"secondary",onClick:V,children:_jsxruntime.jsx.call(void 0, _chunkSKRBKJ52js.b,{height:24,width:24})})),(s==="Missed"||s==="Continue Watching")&&m&&_jsxruntime.jsx.call(void 0, _chunkHX4MSBP2js.a,{topicColor:p}),s==="Completed"&&m&&_jsxruntime.jsx.call(void 0, _chunkO75FFXETjs.a,{topicColor:p})]})]}),O?_jsxruntime.jsx.call(void 0, _chunkOSLA7LY6js.a,{progress:c}):""]})]}),_jsxruntime.jsxs.call(void 0, se,{children:[_jsxruntime.jsxs.call(void 0, ie,{children:[_jsxruntime.jsx.call(void 0, me,{as:"div",variant:"default",size:"small",children:R}),_jsxruntime.jsx.call(void 0, oe,{as:"div",variant:"p2",$topicColor:p,children:B})]}),_jsxruntime.jsx.call(void 0, ne,{variant:"h5",children:g}),o?_jsxruntime.jsx.call(void 0, re,{title:o,children:v?_jsxruntime.jsx.call(void 0, "a",{href:v||"",title:o,onClick:Y,children:o}):o}):"",_jsxruntime.jsx.call(void 0, le,{title:f,children:f})]})]})}),Le= exports.a =ce;exports.a = Le;
